@if (zbChart) {
  <section>
    <span class="sr-only">{{ reportLabel }}</span>
    <table class="styled-table color-print">
      <thead>
        @if (isPrinting) {
          <tr>
            <th id="print-header" colspan="2">
              <zbp-printable-report-heading [headings]="printableReportHeadings"/>
            </th>
          </tr>
        }
      <tr>
        <th>
          <div class="left-header">
            @if (showProgressReportsHelp) {
              <zbp-button-component
                [iconName]="helpMenuIconName"
                theme="icon"
                (clickHandler)="onReportHelpButtonClick()"
                ariaLabel="Information about reports"
              />
            }
            <span class="left-header-text">{{ leftHeaderText }}</span>
          </div>
        </th>
        <th class="right-header-text">{{ rightHeaderText }}</th>
      </tr>
      </thead>
      <tbody>
        @if (zbChart.legend) {
          <tr>
            <td colspan="2">
              <div class="legend">
                @for (value of zbChart.legend; track $index) {
                  <button
                    type="button"
                    class="legendButton"
                    (click)="handleLegendClick(value.id)"
                    [class.disabled]="isDisabledStatus(value.id)"
                    [attr.aria-pressed]="!isDisabledStatus(value.id)"
                  >
                    <div
                      class="color-patch"
                      [class.disabled]="isDisabledStatus(value.id)"
                      [style.--legend-color]="value.color"
                    ></div>
                    {{ value.label }}
                  </button>
                }
              </div>
            </td>
          </tr>
        }
        @for (data of barsToDisplay; track $index) {
          <tr>
            <td class="row-label" role="rowheader">{{ data.label }}</td>
            <td
              class="bar-wrapper"
              (mouseenter)="hoverEnter(data, $event)"
              (mouseleave)="hoverLeave()"
            >
              <button
                class="bar-button"
                [style.--bar-total]="data.fullLengthButton ? 1 : data.totalCount"
                [ariaLabel]="data.ariaLabel"
                (focus)="focusEnter(data, $event)"
                (blur)="focusLeave()"
                (click)="data?.onClick ? data.onClick() : undefined"
                (keydown.escape)="closeTooltip()"
              >
                @for (bar of data.values; track $index) {
                  @if ((data.fullLengthButton || bar.count || zbChart.showZeroCount) && !isDisabledStatus(bar.legendId)) {
                    <div
                      class="bar-body"
                      [class.zero-count]="bar.count === 0"
                      [style.--bar-count]="data.fullLengthButton ? 1 : Math.round(bar.count)"
                      [style.--bar-color]="bar.color"
                      [style.--border-color]="bar.borderColor"
                      [style.--border-style]="bar.borderStyle ?? BorderStyles.solid"
                    >
                      @if (zbChart.showZeroCount && bar.count === 0) {
                        <div
                          class="zero-count-color-patch"
                          [style.--bar-color]="bar.color"
                          [style.--border-color]="bar.borderColor"
                        ></div>
                      }
                      <div
                        class="bar-label"
                        [style.--bar-text-color]="bar.barTextColor"
                        [class.label-on-left]="data.labelOnLeft"
                        [class.label-on-left-with-zero]="data.labelOnLeft && zbChart.showZeroCount && bar.count === 0"
                      >
                        {{ bar.barLabelTranslationKey
                            ? (bar.barLabelTranslationKey | translate)
                            : bar.barLabel }}
                      </div>
                    </div>
                  }
                }
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (useFrontEndPagination && collectionSize > pageSize && !isPrinting) {
      <div class="styled-table-footer-container">
        <nav class="styled-pagination">
          <ngb-pagination
            [pageSize]="pageSize"
            [collectionSize]="collectionSize"
            [page]="page"
            (pageChange)="pageChangeWrapper($event)"
          />
        </nav>
      </div>
    }

    <div
      #floatingTooltip
      class="floating-tooltip"
      [hidden]="!tooltipText || isPrinting"
      [innerHTML]="tooltipText"
      (mouseenter)="onTooltipEnter()"
      (mouseleave)="onTooltipLeave()"
      tabindex="-1"
    ></div>

  </section>
}
